import { render, staticRenderFns } from "./LoginiconWebform.vue?vue&type=template&id=66d238fa&"
import script from "./LoginiconWebform.vue?vue&type=script&lang=ts&"
export * from "./LoginiconWebform.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports